import { render, staticRenderFns } from "./MetricSelect.vue?vue&type=template&id=08fb5e91&"
import script from "./MetricSelect.vue?vue&type=script&lang=ts&"
export * from "./MetricSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports